module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete_competitor":"Delete competitor","yes":"Yes","no":"No","areYouSure":"Are you sure ?"},"fr":{"delete_competitor":"Supprimer concurrent","yes":"Oui","no":"Non","areYouSure":"Etes-vous sûr ?"},"de":{"delete_competitor":"Wettbewerber löschen","yes":"Ja","no":"Nicht","areYouSure":"Bist du dir sicher ?"}}')
  delete Component.options._Ctor
}
